import React, { useState, useEffect } from 'react';

const LoadingAnimation = ({ message = "טוען..." }) => {
    const [currentIcon, setCurrentIcon] = useState(0);
    
    // Detailed house and apartment building SVG icons
    const icons = [
        // Modern house icon
        <svg key="house" xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            {/* Add roof details */}
            <path d="M7 8.5l5-5 5 5" strokeLinecap="round" />
            {/* Add window */}
            <rect x="8" y="14" width="3" height="3" rx="0.5" />
        </svg>,
        // Detailed apartment building icon
        <svg key="building" xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            {/* Main building structure */}
            <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16" />
            {/* Windows */}
            <rect x="7" y="6" width="2" height="2" />
            <rect x="11" y="6" width="2" height="2" />
            <rect x="15" y="6" width="2" height="2" />
            <rect x="7" y="10" width="2" height="2" />
            <rect x="11" y="10" width="2" height="2" />
            <rect x="15" y="10" width="2" height="2" />
            <rect x="7" y="14" width="2" height="2" />
            <rect x="11" y="14" width="2" height="2" />
            <rect x="15" y="14" width="2" height="2" />
            {/* Door */}
            <path d="M10 21v-3a1 1 0 011-1h2a1 1 0 011 1v3" />
            {/* Ground */}
            <path d="M4 21h16" />
        </svg>
    ];

    // Log when the component mounts and unmounts
    useEffect(() => {
        console.log('LoadingAnimation mounted');
        return () => console.log('LoadingAnimation unmounted');
    }, []);

    // Separate useEffect for icon switching
    useEffect(() => {
        console.log('Starting icon switching interval');
        const interval = setInterval(() => {
            setCurrentIcon(prev => {
                const next = (prev + 1) % icons.length;
                console.log(`Switching icon from ${prev} to ${next}`);
                return next;
            });
        }, 200);

        return () => {
            console.log('Clearing icon switching interval');
            clearInterval(interval);
        };
    }, []);

    // Log when currentIcon changes
    useEffect(() => {
        console.log('Current icon index:', currentIcon);
    }, [currentIcon]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-gray-800 rounded-lg p-6 flex flex-col items-center gap-4">
                <div className="text-amber-400 animate-pulse">
                    {icons[currentIcon]}
                </div>
                <p className="text-white">{message}</p>
            </div>
        </div>
    );
};

export default LoadingAnimation; 